import LoaderSuspense from './_loader-suspense.js'
import FlexPane from './_flex-pane.js'
import Swiper from './_swiper.js'
import BannerPromotion from './_banner-promotion.js'
import BannerSkeletons from './_banner-skeletons.js'
import ConfigurableMargin from './_configurable-margin.js'

export default {
  name: 'BannerPromotionsView',
  values: {
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        style: {
          container: {
            display: 'block',
            width: '100%',
          },
          hidden: {
            display: 'block',
            position: 'absolute',
            opacity: 0,
          },
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
      },
    },
    innerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          alignItems: 'center',
          _mobile_padding: '4px 0',
        },
      },
    },
    stacked: false,
    swiper: {
      configSet: Swiper,
      configValues: {
        loop: true,
        autoPlay: true,
        centerViewableSlide: true,
        lazyLoadBufferSize: 1,
        minViewableBufferSize: 1,
        style: {
          gap: '8px',
          _mobile_gap: '4px',
          width: '100%',
          aspectRatio: '3.2 / 1',
          _mobile_aspectRatio: '2.75 / 1',
        },
        slide: {
          style: {
            flexGrow: 1,
            flexShrink: 0,
            _mobile_flexBasis: '90%',
          },
        },
      },
    },
    banner: {
      configSet: BannerPromotion,
      configValues: {
        image: {
          style: {
            objectFit: 'cover',
          },
        },
      },
    },
    skeletonsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          width: '100%',
          _mobile_padding: '4px 0',
        },
      },
    },
    bannerSkeletons: {
      configSet: BannerSkeletons,
      configValues: {
        container: {
          style: {
            _mobile_padding: 0,
          },
        },
      },
    },
    $mixin: [
      {
        configSet: ConfigurableMargin,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
